/* eslint-disable react-hooks/exhaustive-deps */
import "./themes/generated/dx.generic.light.css";
import "./themes/generated/dx.generic.dark.css";
import "./dx-styles-light.scss";
import React, { createContext, useEffect } from "react";
import { HashRouter as Router } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { Provider } from "react-redux";
import { NavigationProvider } from "./contexts/navigation";
import { AuthProvider, useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import { store } from "./redux/store";
import useTheme from "./services/theme";
import useLanguage from "./services/language";
// import { requestForToken } from "./services/firebase";
// import { isSupported } from "firebase/messaging";

export const ColorModeContext = createContext();
export const LanguageContext = createContext();
export const AnnouncementContext = createContext();

function App() {
  const { user, loading } = useAuth();
  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const { themeColor, setTheme, changeTheme } = useTheme();
  const { language, setLanguage } = useLanguage();

  // function requestPermission() {
  //   if ("PushManager" in window) {
  //     Notification.requestPermission().then((permission) => {
  //       if (permission === "granted") {
  //         requestForToken();
  //         // console.log("Notification permission granted.");
  //       } else {
  //         // console.log("Unable to get permission to notify.");
  //       }
  //     });
  //   } else {
  //     // Push isn't supported on this browser, show UI to request user
  //     // subscribe to email notifications.
  //   }
  // }

  useEffect(() => {
    themeColor === "light"
      ? document.body.classList.add("dx-swatch-light")
      : document.body.classList.add("dx-swatch-dark");

    // if (isSupported()) {
    //   requestPermission();
    // }
  }, []);

  return (
    <Router>
      <Provider store={store}>
        <AuthProvider>
          <ColorModeContext.Provider
            value={{ setTheme, themeColor, changeTheme }}
          >
            <LanguageContext.Provider value={{ language, setLanguage }}>
              <NavigationProvider>
                <div className={`app ${screenSizeClass} dx-swatch-light`}>
                  <App />
                </div>
              </NavigationProvider>
            </LanguageContext.Provider>
          </ColorModeContext.Provider>
        </AuthProvider>
      </Provider>
    </Router>
  );
}
